/** Display card replies without transport IDs; the model still receives exact selections. */
export function cardReplyDisplay(text: string): string {
  const oldVideoReply =
    'Create the requested video with these selected clips. Keep these saved request settings and wait for my approval before rendering: ';
  if (text.startsWith(oldVideoReply)) {
    try {
      const request = JSON.parse(text.slice(oldVideoReply.length));
      if (
        request.kind === 'video' &&
        Array.isArray(request.sourceAssetIds) &&
        request.sourceAssetIds.length &&
        request.sourceAssetIds.every((id: unknown) => typeof id === 'string')
      ) {
        return `Use these ${request.sourceAssetIds.length} clips for the video.`;
      }
    } catch {
      /* Keep ordinary or malformed text intact. */
    }
  }
  const selection = text.match(
    /^(?:Use these (?:items|photos|clips):|I've selected these assets for the requested draft\. Continue the current request with them in this order:)\n([\s\S]+)$/
  );
  if (selection) {
    const lines = selection[1].split('\n');
    const names = lines.map((line) => line.match(/^- (.+) \([^()\n]+\)$/)?.[1]);
    if (names.every(Boolean)) {
      const kind = text.startsWith('Use these photos:')
        ? 'photo'
        : text.startsWith('Use these clips:')
          ? 'clip'
          : 'item';
      return `Use the ${kind}${names.length === 1 ? '' : 's'} I picked.`;
    }
  }
  return text
    .replace(/^Use this one: .+ \([^()\n]+\)\.$/, 'Use the photo I picked.')
    .replace(
      /^(Use the existing (?:campaign|lead form) ".+") \([^()\n]+\)\.$/,
      '$1.'
    );
}

/** The recovery card owns the explanation; do not repeat the model's prose above it. */
export function hasVideoFootageRecoveryCard(
  parts: readonly unknown[]
): boolean {
  return parts.some((part) => {
    if (!part || typeof part !== 'object' || !('output' in part)) return false;
    const output = part.output;
    if (!output || typeof output !== 'object' || !('presentation' in output))
      return false;
    const presentation = output.presentation;
    return (
      !!presentation &&
      typeof presentation === 'object' &&
      'type' in presentation &&
      presentation.type === 'video_footage_required'
    );
  });
}

export function footageRecoveryMessage(message: string): string {
  if (message.includes('duration of some selected clips'))
    return "We can't create this video yet because some clips are still processing. Wait for them to finish or choose other footage.";
  const required = message.match(/Required: ([^\n]+?)\. Add/);
  return `We can't create this video yet. Your uploaded clips and matching stock footage don't cover this template. Add or choose more suitable footage to continue.${required ? ` Required: ${required[1]}.` : ''}`;
}
